// extracted by mini-css-extract-plugin
module.exports = {"gameDuration":"TimerForm_gameDuration__10vC9","duration":"TimerForm_duration__2xssf","durationSetter":"TimerForm_durationSetter__12eFF"};